var ActionNames, calcApiLoaded, calcAverage, calcCentre, calcMarkers, calcPlaces, combineReducers;

combineReducers = require('redux').combineReducers;

ActionNames = require('./ActionNames');

calcMarkers = function(state, action) {
  var _, all, i, ix, j, len, marker, newMarkers, results;
  if (state == null) {
    state = [];
  }
  switch (action.type) {
    case ActionNames.MarkerAdded:
      all = (function() {
        var j, len, results;
        results = [];
        for (j = 0, len = state.length; j < len; j++) {
          marker = state[j];
          results.push(marker);
        }
        return results;
      })();
      all.push(action.marker);
      return all;
    case ActionNames.MarkerRemoved:
      results = [];
      for (j = 0, len = state.length; j < len; j++) {
        marker = state[j];
        if (marker !== action.marker) {
          results.push(marker);
        }
      }
      return results;
    case ActionNames.MarkerMoved:
      ix = ((function() {
        var k, len1, results1;
        results1 = [];
        for (i = k = 0, len1 = state.length; k < len1; i = ++k) {
          _ = state[i];
          if (_.id === action.marker.id) {
            results1.push(i);
          }
        }
        return results1;
      })())[0];
      newMarkers = [].concat(state.slice(0, ix));
      newMarkers.push(action.marker);
      newMarkers = newMarkers.concat(state.slice(ix + 1));
      return newMarkers;
    default:
      return state;
  }
};

calcApiLoaded = function(state, action) {
  if (state == null) {
    state = false;
  }
  switch (action.type) {
    case ActionNames.ApiLoaded:
      return action.apiLoaded;
    default:
      return state;
  }
};

calcCentre = function(state, action) {
  if (state == null) {
    state = {
      lat: 52.040191,
      lng: -2.132721
    };
  }
  switch (action.type) {
    case ActionNames.CentreChanged:
      return action.centre;
    default:
      return state;
  }
};

calcAverage = function(markers, action) {
  var av, lat, lng, weightingTotal;
  if (markers == null) {
    markers = [];
  }
  if (markers.length === 0) {
    return null;
  }
  weightingTotal = markers.reduce((function(sum, val) {
    return sum + val.weight;
  }), 0);
  if (weightingTotal === 0) {
    return null;
  }
  lat = (markers.reduce((function(sum, val) {
    return sum + (val.position.lat * val.weight);
  }), 0)) / weightingTotal;
  lng = (markers.reduce((function(sum, val) {
    return sum + (val.position.lng * val.weight);
  }), 0)) / weightingTotal;
  return av = {
    lat: lat,
    lng: lng
  };
};

calcPlaces = function(state, action) {
  if (state == null) {
    state = [];
  }
  switch (action.type) {
    case ActionNames.PlacesChanged:
      return action.places;
    default:
      return state;
  }
};

module.exports = function(state, action) {
  var markers;
  markers = calcMarkers(state != null ? state.markers : void 0, action);
  return {
    markers: markers,
    apiLoaded: calcApiLoaded(state != null ? state.apiLoaded : void 0, action),
    centre: calcCentre(state != null ? state.centre : void 0, action),
    average: calcAverage(markers, action),
    places: calcPlaces(state != null ? state.places : void 0, action)
  };
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3dvcmsvc3JjL3N0YXRlL1JlZHVjZXIuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3dvcmsvc3JjL3N0YXRlL1JlZHVjZXIuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUE7O0FBQUUsa0JBQW9CLE9BQUEsQ0FBUSxPQUFSOztBQUN0QixXQUFBLEdBQWMsT0FBQSxDQUFRLGVBQVI7O0FBRWQsV0FBQSxHQUFjLFNBQUMsS0FBRCxFQUFhLE1BQWI7QUFDYixNQUFBOztJQURjLFFBQVE7O0FBQ3RCLFVBQU8sTUFBTSxDQUFDLElBQWQ7QUFBQSxTQUNNLFdBQVcsQ0FBQyxXQURsQjtNQUVFLEdBQUE7O0FBQU87YUFBQSx1Q0FBQTs7dUJBQUE7QUFBQTs7O01BQ1AsR0FBRyxDQUFDLElBQUosQ0FBUyxNQUFNLENBQUMsTUFBaEI7YUFDQTtBQUpGLFNBTU0sV0FBVyxDQUFDLGFBTmxCO0FBT0c7V0FBQSx1Q0FBQTs7WUFBZ0MsTUFBQSxLQUFZLE1BQU0sQ0FBQzt1QkFBbkQ7O0FBQUE7O0FBUEgsU0FTTSxXQUFXLENBQUMsV0FUbEI7TUFVRSxFQUFBLEdBQUs7O0FBQUM7YUFBQSxpREFBQTs7Y0FBd0IsQ0FBQyxDQUFDLEVBQUYsS0FBUSxNQUFNLENBQUMsTUFBTSxDQUFDOzBCQUE5Qzs7QUFBQTs7VUFBRCxDQUFtRCxDQUFBLENBQUE7TUFDeEQsVUFBQSxHQUFhLEVBQUUsQ0FBQyxNQUFILENBQVUsS0FBTSxhQUFoQjtNQUNiLFVBQVUsQ0FBQyxJQUFYLENBQWdCLE1BQU0sQ0FBQyxNQUF2QjtNQUNBLFVBQUEsR0FBYSxVQUFVLENBQUMsTUFBWCxDQUFrQixLQUFNLGNBQXhCO2FBQ2I7QUFkRjthQWdCTTtBQWhCTjtBQURhOztBQW1CZCxhQUFBLEdBQWdCLFNBQUMsS0FBRCxFQUFnQixNQUFoQjs7SUFBQyxRQUFROztBQUN4QixVQUFPLE1BQU0sQ0FBQyxJQUFkO0FBQUEsU0FDTSxXQUFXLENBQUMsU0FEbEI7YUFDaUMsTUFBTSxDQUFDO0FBRHhDO2FBRU07QUFGTjtBQURlOztBQUtoQixVQUFBLEdBQWEsU0FBQyxLQUFELEVBQTJDLE1BQTNDOztJQUFDLFFBQVE7TUFBQyxHQUFBLEVBQUssU0FBTjtNQUFpQixHQUFBLEVBQUssQ0FBQyxRQUF2Qjs7O0FBQ3JCLFVBQU8sTUFBTSxDQUFDLElBQWQ7QUFBQSxTQUNNLFdBQVcsQ0FBQyxhQURsQjthQUNxQyxNQUFNLENBQUM7QUFENUM7YUFFTTtBQUZOO0FBRFk7O0FBS2IsV0FBQSxHQUFjLFNBQUMsT0FBRCxFQUFlLE1BQWY7QUFDYixNQUFBOztJQURjLFVBQVU7O0VBQ3hCLElBQWUsT0FBTyxDQUFDLE1BQVIsS0FBa0IsQ0FBakM7QUFBQSxXQUFPLEtBQVA7O0VBRUEsY0FBQSxHQUFpQixPQUFPLENBQUMsTUFBUixDQUFlLENBQUMsU0FBQyxHQUFELEVBQU0sR0FBTjtXQUFjLEdBQUEsR0FBTSxHQUFHLENBQUM7RUFBeEIsQ0FBRCxDQUFmLEVBQWlELENBQWpEO0VBQ2pCLElBQWUsY0FBQSxLQUFrQixDQUFqQztBQUFBLFdBQU8sS0FBUDs7RUFFQSxHQUFBLEdBQU0sQ0FBQyxPQUFPLENBQUMsTUFBUixDQUFlLENBQUMsU0FBQyxHQUFELEVBQU0sR0FBTjtXQUFjLEdBQUEsR0FBTSxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsR0FBYixHQUFtQixHQUFHLENBQUMsTUFBeEI7RUFBcEIsQ0FBRCxDQUFmLEVBQXNFLENBQXRFLENBQUQsQ0FBQSxHQUE0RTtFQUNsRixHQUFBLEdBQU0sQ0FBQyxPQUFPLENBQUMsTUFBUixDQUFlLENBQUMsU0FBQyxHQUFELEVBQU0sR0FBTjtXQUFjLEdBQUEsR0FBTSxDQUFDLEdBQUcsQ0FBQyxRQUFRLENBQUMsR0FBYixHQUFtQixHQUFHLENBQUMsTUFBeEI7RUFBcEIsQ0FBRCxDQUFmLEVBQXNFLENBQXRFLENBQUQsQ0FBQSxHQUE0RTtTQUNsRixFQUFBLEdBQUs7SUFBQyxLQUFBLEdBQUQ7SUFBSyxLQUFBLEdBQUw7O0FBUlE7O0FBVWQsVUFBQSxHQUFhLFNBQUMsS0FBRCxFQUFhLE1BQWI7O0lBQUMsUUFBUTs7QUFDckIsVUFBTyxNQUFNLENBQUMsSUFBZDtBQUFBLFNBQ00sV0FBVyxDQUFDLGFBRGxCO2FBQ3FDLE1BQU0sQ0FBQztBQUQ1QzthQUVNO0FBRk47QUFEWTs7QUFLYixNQUFNLENBQUMsT0FBUCxHQUFpQixTQUFDLEtBQUQsRUFBUSxNQUFSO0FBQ2hCLE1BQUE7RUFBQSxPQUFBLEdBQVUsV0FBQSxpQkFBWSxLQUFLLENBQUUsZ0JBQW5CLEVBQTRCLE1BQTVCO1NBQ1Y7SUFDQyxTQUFBLE9BREQ7SUFFQyxTQUFBLEVBQVcsYUFBQSxpQkFBYyxLQUFLLENBQUUsa0JBQXJCLEVBQWdDLE1BQWhDLENBRlo7SUFHQyxNQUFBLEVBQVEsVUFBQSxpQkFBVyxLQUFLLENBQUUsZUFBbEIsRUFBMEIsTUFBMUIsQ0FIVDtJQUlDLE9BQUEsRUFBUyxXQUFBLENBQVksT0FBWixFQUFxQixNQUFyQixDQUpWO0lBS0MsTUFBQSxFQUFRLFVBQUEsaUJBQVcsS0FBSyxDQUFFLGVBQWxCLEVBQTBCLE1BQTFCLENBTFQ7O0FBRmdCIn0=
